<template>
  <div class="code-content">
    <div style="width: 100%" v-if="bookInfo && bookInfo.status === 1">
      <div class="aui-product-content">
        <el-image
          style="width: 100%"
          :src="bookInfo.bookIcon"
          fit="cover"
        ></el-image>
      </div>
      <div class="aui-product-content">
        <el-row>
          <el-col :span="24">
            <div class="aui-real-price">
              <span class="activation-label">激活码</span>
              <span class="activation-code">{{ code }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row style="margin-top: 2em">
          <el-col :span="24">
            <div class="aui-product-title">
              <span>{{ bookInfo.name }}</span>
            </div>
          </el-col>
        </el-row>

        <el-row style="margin-top: 2em">
          <el-col :span="24">
            <div class="aui-product-title">
              <span
                >请在“标准日本语App”中激活后使用，
                <el-link
                  type="primary"
                  href="https://ebook.pep.com.cn/lry"
                  style="
                    font-size: 1em;
                    font-weight: 400;
                    vertical-align: baseline;
                    text-decoration: underline;
                  "
                  >立即下载</el-link
                >。
              </span>
            </div>
          </el-col>
        </el-row>

        <el-row
          style="margin-top: 2em"
          v-if="BookId === 10007 || BookId === 10008"
        >
          <el-col :span="24">
            <div class="aui-product-title">
              <span
                >也可通过
                <el-link
                  type="primary"
                  href="https://ebook.pep.com.cn/lry"
                  style="
                    font-size: 1em;
                    font-weight: 400;
                    vertical-align: baseline;
                    text-decoration: underline;
                  "
                  >标准日本语web版</el-link
                >
                和
                <el-link
                  type="primary"
                  href="https://ebook.pep.com.cn/lry"
                  style="
                    font-size: 1em;
                    font-weight: 400;
                    vertical-align: baseline;
                    text-decoration: underline;
                  "
                  >标准日本语微信小程序</el-link
                >
                使用。
              </span>
            </div>
          </el-col>
        </el-row>

        <el-row style="margin-top: 2em" v-if="BookId === 10016">
          <el-col :span="24">
            <div class="aui-product-title">
              <span
                >有任何问题，欢应通过“标日电子叔”微信公众号与我们联系。
              </span>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="aui-product-content" v-if="BookId === 10016">
        <img
          class="qr-code-image"
          src="@/assets/images/brgzhewm.jpg"
          fit="cover"
        />
      </div>
    </div>
    <div v-if="bookInfo && bookInfo.status === 2" class="error-message">
      <span>暂时没有查到此激活码，谨防假冒！</span>
    </div>
    <div style="width: 100%">
      <div class="aui-product-content">
        <el-row style="margin-top: 2em">
          <el-col :span="24">
            <div style="height: 30em"></div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { queryCodeDB } from "@/interface";
import { bookSort } from "@/utils/bookManage";
import { aes128Decrypt } from "@/utils/aes128";

export default {
  name: "Help",
  components: {},
  props: {},
  data() {
    return {
      isHelp: true,
      code: "",
      BookId: "",
      bookInfo: {
        status: 0,
      },
    };
  },
  computed: {},
  mounted() {
    // console.log('路由参数:', this.$route.params.param);
    this.code = this.$route.params.param;
    this.queryCode();
  },
  methods: {
    queryCode() {
      const params = {
        activation_code: this.code,
      };
      queryCodeDB(params).then((res) => {
        if (res.status !== 200) {
          return;
        }
        const data = aes128Decrypt(res.data) || {};
        const newVl = data.BookId;
        const matchedBook = bookSort[newVl];
        this.BookId = newVl;

        if (newVl && matchedBook && matchedBook.imgName) {
          this.bookInfo = {
            ...matchedBook,
            bookIcon: require(`@/assets/images/book_cover_high/${matchedBook.imgName}`),
            status: 1,
          };
        } else {
          this.bookInfo = {
            status: 2,
          };
        }
        // console.log(this.bookInfo)
      });
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  display: block;
  unicode-bidi: isolate;
}

.code-content {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-size: 12px;

  .aui-product-content {
    font-family: "SimKai", "KaiTi", "楷体", serif;
    padding: 3em;
  }

  .aui-real-price {
    width: 100%;
    color: #d4244e;
  }

  .aui-settle-choice {
    width: 100%;
  }

  .aui-product-title {
    width: 100%;
    outline: none;
    font-size: 3em;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    word-break: break-word;

    span,
    a {
      white-space: normal;
      display: inline;
      word-break: break-word;
    }

    a {
      text-decoration: underline;
      color: #409eff;

      &:hover {
        color: #66b1ff;
      }
    }
  }

  .activation-label {
    padding: 10px;
    border-radius: 10px;
    border: 5px solid #f56c6c;
    font-size: 2em;
    vertical-align: super;
    white-space: nowrap;
    display: inline-block;
  }

  .activation-code {
    user-select: all;
    margin-left: 1em;
    font-size: 4em;
    white-space: nowrap;
    display: inline-block;
  }

  .qr-code-image {
    width: 70%;
    margin: 0 auto;
    display: block;
  }

  .error-message {
    text-align: center;

    span {
      font-size: 4em;
    }
  }
}

// 移动端响应式样式
@media (max-width: 1024px) {
  .code-content {
    .aui-product-content {
      padding: 2em 1.5em !important;
    }

    .aui-real-price {
      span:first-child {
        padding: 8px !important;
        border-radius: 8px !important;
        border: 3px solid #f56c6c !important;
        font-size: 1.5em !important;
        white-space: nowrap !important;
        display: inline-block !important;
      }

      span:last-child {
        font-size: 2.5em !important;
        margin-left: 0.5em !important;
        white-space: nowrap !important;
        display: inline-block !important;
      }
    }

    .aui-product-title {
      font-size: 2em !important;
      line-height: 1.4 !important;
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
      word-break: break-word !important;

      span,
      a {
        white-space: normal !important;
        display: inline !important;
        word-break: break-word !important;
      }

      a {
        text-decoration: underline !important;
        color: #409eff !important;
        font-weight: 400 !important;
      }
    }

    .error-message span {
      font-size: 2.5em !important;
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
      word-break: break-word !important;
    }

    img {
      width: 80% !important;
    }
  }
}

@media (max-width: 768px) {
  .code-content {
    .aui-product-content {
      padding: 1.5em 1em !important;
    }

    .aui-real-price {
      span:first-child {
        padding: 6px !important;
        border-radius: 6px !important;
        border: 2px solid #f56c6c !important;
        font-size: 1.2em !important;
        white-space: nowrap !important;
        display: inline-block !important;
      }

      span:last-child {
        font-size: 2em !important;
        margin-left: 0.3em !important;
        white-space: nowrap !important;
        display: inline-block !important;
      }
    }

    .aui-product-title {
      font-size: 1.5em !important;
      line-height: 1.3 !important;
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
      word-break: break-word !important;

      span,
      a {
        white-space: normal !important;
        display: inline !important;
        word-break: break-word !important;
      }

      a {
        text-decoration: underline !important;
        color: #409eff !important;
        font-weight: 400 !important;
      }
    }

    .error-message span {
      font-size: 2em !important;
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
      word-break: break-word !important;
    }

    img {
      width: 85% !important;
    }
  }
}

@media (max-width: 480px) {
  .code-content {
    .aui-product-content {
      padding: 1em 0.8em !important;
    }

    .aui-real-price {
      span:first-child {
        padding: 5px !important;
        border-radius: 5px !important;
        border: 2px solid #f56c6c !important;
        font-size: 1em !important;
        white-space: nowrap !important;
        display: inline-block !important;
      }

      span:last-child {
        font-size: 1.5em !important;
        margin-left: 0.2em !important;
        white-space: nowrap !important;
        display: inline-block !important;
      }
    }

    .aui-product-title {
      font-size: 1.2em !important;
      line-height: 1.2 !important;
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
      word-break: break-word !important;

      span,
      a {
        white-space: normal !important;
        display: inline !important;
        word-break: break-word !important;
      }

      a {
        text-decoration: underline !important;
        color: #409eff !important;
        font-weight: 400 !important;
      }
    }

    .error-message span {
      font-size: 1.5em !important;
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
      word-break: break-word !important;
    }

    img {
      width: 90% !important;
    }
  }
}
</style>
